/**
 *    __________ ______ Copyright (C) Smart Software Factory SA de CV
 *   / ___/ ___// ____/ All Rights Reserved
 *   \__ \__ \ / /_     Unauthorized copying of this file,
 *  ___/ /__/ / __/     via any medium is strictly prohibited
 * /____/____/_/        Proprietary and confidential
 *
 * Written by Ricardo Sansores <ricardo@ssf.mx>, May 2019
 * Edit by David Canul, 27 may 2019
 *
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Form, { FormComponentProps } from 'antd/lib/form';
import { RootState } from 'store/configureStore';
import {
  Card,
  Button,
  Input,
  Col,
  Row,
  Select,
  List,
  InputNumber,
  Spin,
  Tag,
  message,
} from 'antd';
import { Strings as i8n } from 'commons/strings';
import { getUserAction, saveuser, getFiscalData } from './redux/actions';
import {
  saveInvoiceAndCancel,
  saveInvoiceAndCancelMultiple,
  removeSaleToStagingArea,
  addSaleToStagingArea,
} from 'routes/invoices/redux/actions';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { UserSavedI } from 'routes/users/redux/reducers';
import { Permission, User, Sale, FiscalData, Invoice } from 'types/type';
import moment from 'moment';
import { Popups } from 'commons/components/popups/popups';
import { getDecodeToken } from 'security';
import { InvoiceRules } from 'routes/invoices/components/FiscalData/rulesFiscalData';
import MaskedInput from 'react-text-mask';
import { isEmpty } from 'lodash';
import { isCancelable } from 'commons/functions';
import { Redirect } from 'react-router';
import './style.css';
import FiscalDataService from 'services/fiscalData';
import ScannerButton from 'routes/qr/ScannerButton';
const fiscalDataService = new FiscalDataService();

interface DispatchProps {
  getUserAction: (id: string) => void;
  saveuser: (user: User) => void;
  removeSaleToStagingArea: (item: Sale) => void;
  getFiscalData: (userId: string) => void;
  saveInvoiceAndCancel: (invoice: Invoice, userId: string) => void;
  saveInvoiceAndCancelMultiple: (invoice: Invoice, userId: string) => void;
  addSaleToStagingArea: (ius: string, total: number, clean: boolean) => void;
}

interface HomeRouterProps {
  id: string;
}

interface StateProps {
  user: UserSavedI;
  isFetching: boolean;
  permissionList: Permission[];
  fiscalDataList: FiscalData[];
  readonly salesStagingArea: Sale[];
}

type Props = FormComponentProps &
  StateProps &
  DispatchProps &
  RouteComponentProps<HomeRouterProps>;

class InvoiceUser extends Component<Props> {
  public state = {
    ius: '',
    total: 0,
    fiscaldata: null,
    email: '',
    selectedRFC: null,
    currentRFCValue: '',
    currentFiscalDataValue: '',
    selectedRFcID: null,
    usoCFDI: [],
    regimenFiscal: [],
    formasPago: [],
  };

  private iusMakedRef: React.RefObject<MaskedInput>;

  constructor(props: Props) {
    super(props);
    this.iusMakedRef = React.createRef();
  }

  componentDidMount() {
    const { getFiscalData, addSaleToStagingArea, form } = this.props;
    addSaleToStagingArea('0', 0, true);
    form.resetFields();
    getFiscalData(getDecodeToken().id);
    fiscalDataService.fiscalDataList().then((response) => {
      this.setState({
        usoCFDI: response.useCFDIS,
        regimenFiscal: response.regimenFiscals,
        formasPago: response.paymentCode,
      });
    });
  }

  componentWillUnmount() {
    this.props.addSaleToStagingArea('0', 0, true);
  }

  public onChangeRfc = (fiscalDataId: string): void => {
    const fiscalData = this.props.fiscalDataList.find(
      (fd) => fd.id === fiscalDataId,
    );
    if (fiscalData) {
      this.setState({
        fiscalData,
        fiscaldata: fiscalData,
        selectedRFC: fiscalData.rfc,
        currentRFCValue: fiscalDataId,
        currentFiscalDataValue: fiscalData.id,
        selectedRFcID: fiscalData.id,
      });
      this.props.form.setFieldsValue({
        email: fiscalData.email,
      });
    }
  };

  public onChangeFiscalData = (fiscalDataId: string): void => {
    const fiscalData = this.props.fiscalDataList.find(
      (fd) => fd.id === fiscalDataId,
    );
    if (fiscalData) {
      this.setState({
        fiscalData,
        fiscaldata: fiscalData,
        selectedRFC: fiscalDataId,
        currentRFCValue: fiscalData.id,
        currentFiscalDataValue: fiscalDataId,
        selectedRFcID: fiscalData.id,
      });
      this.props.form.setFieldsValue({
        email: fiscalData.email,
      });
    }
  };

  private onContinueScanner = async (sales: Sale[]) => {
    const toAdd = sales.filter(
      (sale) =>
        !this.props.salesStagingArea.some((s) => s.IUSCode === sale.IUSCode),
    );
    for (const sale of toAdd) {
      await this.props.addSaleToStagingArea(
        `${sale.IUSCode.toUpperCase()}`,
        sale.total,
        false,
      );
    }
  };

  public getFiscalDataFromUser = (value: string): string => {
    if (this.state.fiscaldata !== null) {
      switch (value) {
        case 'regimen':
          if (this.state.fiscaldata['fiscalRegime'] !== null) {
            const keyRegime = this.state.fiscaldata['fiscalRegime'];
            const valueRegimen = this.state.regimenFiscal
              .filter((x) => x['code'] === keyRegime)
              .map((item: { code: string; description: string }): string =>
                item.code.concat(' - ').concat(item.description),
              );
            if (valueRegimen[0] !== undefined) return valueRegimen[0];
          }
          break;
        case 'zipCode':
          if (this.state.fiscaldata['zipCode'] !== null)
            return this.state.fiscaldata['zipCode'];
          break;
        case 'domicilio': {
          const fd = this.state.fiscaldata;
          const parts = [
            fd['street'],
            fd['numExt'],
            fd['numInt'] ? `Int. ${fd['numInt']}` : null,
            fd['colony'],
            fd['municipality'],
            fd['city'],
            fd['state'],
          ].filter(Boolean);
          return parts.join(', ');
        }
      }
    }
    return '';
  };

  /* private groupArray(saleList: any[], key: string): Array<any> {
    return saleList.reduce(function (prevValue, currentValue) {
      (prevValue[currentValue[key]] = prevValue[currentValue[key]] || []).push(currentValue);
      return prevValue;
    }, {});
  }; */

  handleOnSubmit = (
    saleBilledAndNotCancellable: boolean,
    isMultiple: boolean,
  ) => {
    if (!this.state.selectedRFcID) {
      message.error('Selecciona un RFC antes de facturar.');
      return;
    }
    const { form, salesStagingArea, fiscalDataList } = this.props;
    if (salesStagingArea.length === 0) {
      message.error('Agrega al menos una venta antes de facturar.');
      return;
    }
    let newSalesStagingArea: any[] = [];
    /*if (salesStagingArea.length > 1 && isMultiple) {
      const groups: Sale[] = this.groupArray(salesStagingArea, "numberPermission");
      for (let i in groups) { newSalesStagingArea.push(groups[i]) }
    } else **/ newSalesStagingArea = [salesStagingArea];

    let error = '';
    form.validateFieldsAndScroll(async (err, values): Promise<void> => {
      if (!err) {
        try {
          for (let i = 0; i <= newSalesStagingArea.length - 1; i++) {
            if (!saleBilledAndNotCancellable) {
              const fiscalData = fiscalDataList.find(
                (fd) => fd.id === this.state.selectedRFcID,
              );
              if (fiscalData) {
                const invoice = {
                  city: fiscalData.city,
                  externalNumber: fiscalData.numExt,
                  internalNumber: fiscalData.numInt,
                  email: values.email,
                  sales: newSalesStagingArea[i],
                  name: fiscalData.businessName,
                  usoCfdi: values.usoCfdi,
                  colony: fiscalData.colony,
                  fiscalRegime: fiscalData.fiscalRegime,
                  municipality: fiscalData.municipality,
                  rfc: fiscalData.rfc,
                  state: fiscalData.state,
                  zipCode: fiscalData.zipCode,
                  street: fiscalData.street,
                  formaPago: values.formaPago,
                  idG4s: '',
                  id: '',
                };
                const id = getDecodeToken().id;
                if (isMultiple)
                  this.props.saveInvoiceAndCancelMultiple(invoice, id);
                else this.props.saveInvoiceAndCancel(invoice, id);
              }
            } else {
              error =
                'Una de las ventas ya ha sido Facturada y no puede ser cancelada.';
              throw new Error(
                'Una de las ventas ya ha sido Facturada y no puede ser cancelada.',
              );
            }
          }
          if (isEmpty(error)) {
            this.props.addSaleToStagingArea('0', 0, true);
            form.resetFields();
            this.props.history.push('/home');
          }
        } catch (erro) {
          Popups.notifyError(error);
        }
      }
    });
  };

  public handleOnSubmitIUS = async (): Promise<void> => {
    try {
      if (
        !isEmpty(this.state.total.toString()) &&
        this.state.ius.trim() !== ''
      ) {
        try {
          await this.props.addSaleToStagingArea(
            `${this.state.ius.toUpperCase()}`,
            this.state.total,
            false,
          );
        } catch (err) {
          Popups.notifyException(err);
        }
        this.setState({ ius: '', total: '' });
      } else {
        throw new Error();
      }
    } catch (error) {
      Popups.notifyError('IUS y monto vacio');
    }
  };

  public renderSalesStagingArea = (): JSX.Element => {
    return (
      <Col style={{ backgroundColor: '#fff' }}>
        {this.props.salesStagingArea.length > 0 ? (
          <Card
            className={'card-invoice-content'}
            type="inner"
            title={i8n.IUS_ADDED_IN_STAGING_AREA}
          >
            <List
              dataSource={this.props.salesStagingArea}
              renderItem={(item: Sale, index: number): JSX.Element => (
                <Col>
                  <List.Item
                    actions={[
                      <button
                        key="1"
                        id={'invoice_delete_' + index.toString()}
                        type="button"
                        className="link-button"
                        onClick={() => {
                          this.props.removeSaleToStagingArea(item);
                        }}
                      >
                        Eliminar
                      </button>,
                    ]}
                  >
                    <List.Item.Meta
                      title={
                        <div id={'invoice_list_' + index.toString()}>
                          {item.IUSCode +
                            ' | $' +
                            item.total +
                            ' | ' +
                            moment(item.endDate).format('DD/MM/YYYY')}
                        </div>
                      }
                    />
                  </List.Item>
                </Col>
              )}
            />
          </Card>
        ) : (
          <Card bordered={false}>
            <div>
              <p />
            </div>
          </Card>
        )}
      </Col>
    );
  };

  public render = (): JSX.Element => {
    if (!getDecodeToken().isClient) {
      return <Redirect to="/home" />;
    }
    const hexRegex = /[0-9a-fA-F]/;
    const iusFragment = [hexRegex, hexRegex, hexRegex, hexRegex];
    const {
      form: { getFieldDecorator },
      user: { usersaved },
      salesStagingArea,
      isFetching,
    } = this.props;
    const saleBilledAndNotCancellable = salesStagingArea.some(
      (s) => s.billed && !isCancelable(s),
    );
    return (
      <Spin tip="Cargando..." spinning={isFetching}>
        <Card>
          <Form>
            <Card className={'customer-card'}>
              <Row gutter={[8, 8]}>
                <Col md={10} sm={24}>
                  <h2 style={{ color: '#296FC4' }}>RFC a facturar </h2>
                  Selecciona un RFC
                </Col>
                <Col md={14} sm={24}>
                  <Col sm={23} md={11}>
                    <label className="label">{'RFC:'}</label>
                    <Select
                      value={this.state.currentRFCValue}
                      defaultActiveFirstOption
                      showSearch
                      onChange={(value) => this.onChangeRfc(value)}
                      filterOption={(input, option) =>
                        (option.props.label as string)
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      optionLabelProp="label"
                      style={{ width: '100%' }}
                    >
                      {this.props.fiscalDataList.map((fs) => (
                        <Select.Option value={fs.id} key={fs.id} label={fs.rfc}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <span>{fs.rfc}</span>
                            {fs.street && (
                              <Tag>
                                {fs.street}
                                {fs.numExt ? ` ${fs.numExt}` : ''}
                              </Tag>
                            )}
                          </div>
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={23} md={11}>
                    <label className="label">{'Razón social'}</label>
                    <Select
                      value={this.state.currentFiscalDataValue}
                      defaultActiveFirstOption
                      showSearch
                      onChange={(value) => this.onChangeFiscalData(value)}
                      optionFilterProp="children"
                      style={{ width: '100%' }}
                    >
                      {this.props.fiscalDataList.map((fs) => (
                        <Select.Option key={fs.id} value={fs.id}>
                          {fs.businessName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={23} md={11}>
                    <Form.Item hasFeedback label="Uso de CFDI">
                      {getFieldDecorator('usoCfdi', {
                        initialValue: 'G03',
                        rules: InvoiceRules.usoCfdiRule,
                      })(
                        <Select showSearch size="large">
                          {this.state.usoCFDI !== undefined &&
                            this.state.usoCFDI.map(
                              (item: {
                                code: string;
                                description: string;
                              }): React.ReactNode => (
                                <Select.Option
                                  key={item.code}
                                  value={item.code}
                                >
                                  <div id={item.code}>
                                    {item.code
                                      .concat(' - ')
                                      .concat(item.description)}
                                  </div>
                                </Select.Option>
                              ),
                            )}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col sm={23} md={11}>
                    <Form.Item hasFeedback label="Correo electróninco">
                      {getFieldDecorator('email', {
                        initialValue: usersaved.email || '',
                        rules: [
                          {
                            required: true,
                            whitespace: true,
                            message: 'Ingresa tu correo',
                          },
                          {
                            max: 100,
                            whitespace: true,
                            message: 'No se permiten mas de 100 caracteres',
                          },
                          {
                            type: 'email',
                            message: 'Ingresa un correo valido',
                          },
                        ],
                      })(
                        <Input size="large" placeholder="Correo electrónico" />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    sm={23}
                    md={11}
                    hidden={this.state.formasPago.length === 0}
                  >
                    <Form.Item hasFeedback label="Forma de Pago">
                      {getFieldDecorator('formaPago', {
                        rules: [
                          {
                            required: this.state.formasPago.length > 0,
                            whitespace: true,
                            message: 'Ingresa la forma de Pago',
                          },
                        ],
                      })(
                        <Select showSearch size="large">
                          {this.state.formasPago !== undefined &&
                            this.state.formasPago.map(
                              (item: {
                                code: string;
                                description: string;
                              }): React.ReactNode => (
                                <Select.Option
                                  key={item.code}
                                  value={item.code}
                                >
                                  <div id={item.code}>
                                    {item.code
                                      .concat(' - ')
                                      .concat(item.description)}
                                  </div>
                                </Select.Option>
                              ),
                            )}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={14}></Col>
                  <Col sm={23} md={22} style={{ marginTop: 8 }}>
                    <Input
                      addonBefore="Domicilio"
                      readOnly
                      disabled
                      value={this.getFiscalDataFromUser('domicilio')}
                    />
                  </Col>
                  <Col sm={23} md={7}>
                    <Input
                      addonBefore="Código Postal"
                      readOnly
                      disabled
                      value={this.getFiscalDataFromUser('zipCode')}
                    />
                  </Col>
                  <Col sm={23} md={15}>
                    <Input
                      addonBefore="Régimen Fiscal"
                      readOnly
                      disabled
                      value={this.getFiscalDataFromUser('regimen')}
                    />
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col md={10} sm={24} style={{ marginBottom: 8 }}>
                  <h2 style={{ color: '#296FC4' }}>Tickets a facturar</h2>
                  Introduce IUS y monto para agregar tickets a facturar
                </Col>
                <Col md={14} sm={24}>
                  {!saleBilledAndNotCancellable ? (
                    <div>
                      <Row
                        gutter={[8, 8]}
                        style={{ backgroundColor: '#f1f7ff' }}
                      >
                        <Col md={11} sm={24}>
                          <label className="label" htmlFor="">
                            IUS
                          </label>
                          <MaskedInput
                            ref={this.iusMakedRef}
                            onChange={(e) =>
                              this.setState({ ius: e.target.value })
                            }
                            value={this.state.ius}
                            mask={[
                              ...iusFragment,
                              '-',
                              ...iusFragment,
                              '-',
                              ...iusFragment,
                              '-',
                              ...iusFragment,
                              '-',
                              ...iusFragment,
                            ]}
                            id="ius"
                            showMask
                            style={{ fontSize: '21px' }}
                            className="ant-input ant-input-large"
                          />
                        </Col>
                        <Col md={12} sm={24}>
                          <Row>
                            <label className="label">Monto $</label>
                          </Row>
                          <InputNumber
                            value={this.state.total}
                            onChange={(text) => this.setState({ total: text })}
                          />
                        </Col>
                      </Row>
                      <Row gutter={[10, 10]}>
                        <Col span={23}>
                          <Row>
                            <Col span={12}>
                              <Button
                                type="dashed"
                                id="search_sale_button"
                                onClick={() => this.handleOnSubmitIUS()}
                              >
                                {' + Añadir  '}
                              </Button>
                            </Col>
                            <Col span={12}>
                              <ScannerButton
                                type="dashed"
                                onContinue={this.onContinueScanner}
                              >
                                Usar QR
                              </ScannerButton>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div>
                      {saleBilledAndNotCancellable &&
                        'Una de las ventas ya ha sido Facturada y no puede ser cancelada.'}
                    </div>
                  )}
                  <Col>{this.renderSalesStagingArea()}</Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row gutter={[8, 8]}>
                <Col sm={23} md={{ span: 4, offset: 10 }}>
                  <Link
                    to="/home"
                    onClick={() =>
                      this.props.addSaleToStagingArea('0', 0, true)
                    }
                  >
                    <Button
                      id="cancel_button"
                      type="default"
                      block
                      size="large"
                    >
                      Cancelar
                    </Button>
                  </Link>
                </Col>
                <Col sm={23} md={4}>
                  <Button
                    className="button-customer-serch-style"
                    block
                    size="large"
                    type="primary"
                    onClick={() =>
                      this.handleOnSubmit(saleBilledAndNotCancellable, false)
                    }
                  >
                    Factura por venta
                  </Button>
                </Col>
                <Col sm={23} md={4}>
                  <Button
                    className="button-customer-serch-style"
                    block
                    size="large"
                    type="primary"
                    onClick={() =>
                      this.handleOnSubmit(saleBilledAndNotCancellable, true)
                    }
                  >
                    Factura Agrupada
                  </Button>
                </Col>
              </Row>
            </Card>
          </Form>
        </Card>
      </Spin>
    );
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    user: states.usersState.usersSave,
    permissionList: states.usersState.permissionList,
    salesStagingArea: states.invoiceState.salesStagingArea,
    fiscalDataList: states.invoiceUserState.fiscalDataList,
    isFetching: states.invoiceState.isFetching,
  };
};

const mapDispatchToProps = {
  getUserAction,
  saveuser,
  getFiscalData,
  addSaleToStagingArea,
  saveInvoiceAndCancel,
  saveInvoiceAndCancelMultiple,
  removeSaleToStagingArea,
};

export default connect<
  StateProps,
  DispatchProps,
  Record<string, unknown>,
  RootState
>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(InvoiceUser));
